<template>
  <div class="doclist">
    <!-- 订阅蒙版 -->
    <el-dialog title="请订阅您感兴趣的内容"
               :visible.sync="isSubscribeMaskShow"
               width="540px"
               class="doc-subscribe-area"
               :close-on-click-modal='false'
               :before-close="cancelSubscribe">
      <div class="doc-subscribe-list">
        <ul v-if="subscribeType"
            class="subscribeFirstType">
          <li v-for="(item, index) in subscribeType"
              :key="index"
              style="
                border-bottom: 1px solid #666666;
                margin-top: 25px;
                margin-bottom: 10px;
              ">
            <div class="subscribeFirstLevel"
                 :class="item.isSubscription ? 'activeSubscribe' : ''"
                 @click="changeFirstLevelSubscribeState(index, item)">
              {{item.fileTypeName}}
            </div>
            <ul class="subscribeSecondType"
                v-if="item.children !== null || item.children.length !== 0">
              <li v-for="(item2, index2) in item.children"
                  :key="index2">
                <div :class="item2.isSubscription ? 'activeSubscribe' : ''"
                     @click="changeSecondLevelSubscribeState(index, item, index2, item2)">
                  {{item2.fileTypeName}}
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="doc-subscribe-function"
           style="width:540px; margin-left: -20px; margin-bottom: -30px;">
        <div class="doc-subscribe-no"
             @click="cancelSubscribe">暂不订阅</div>
        <div class="doc-subscribe-yes"
             @click="handleSubscribe">订阅</div>
      </div>
    </el-dialog>
    <!-- 上传文件蒙版 -->
    <el-dialog title="上传资料"
               :visible.sync="isUploadShow"
               width="530px"
               class="doc-upload-area"
               :close-on-click-modal='false'
               :before-close="cancelUpload">
      <div v-if="isUploadShow">
        <h4 style="text-indent: 20px;">标题：</h4>
        <input type="text"
               v-model="uploadFileTitle"
               placeholder="请输入文档标题（限200字）...">
        <h4 style="text-indent: 20px;">下载所需积分：</h4>
        <input type="text"
               v-model="uploadFileScore"
               placeholder="请输入下载所需积分（0-5）" />
        <h4 style="margin-top: 20px; text-indent: 20px;">描述：</h4>
        <textarea v-model="uploadFileDescribe"
                  placeholder="请输入文档描述（限1000字）..."></textarea>
      </div>
      <div class="doc-upload-typechoose">
        <div v-if="uploadFileTypeChooseOne"
             class="doc-upload-kindonechoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
          <h4 style="padding-left: 20px">分类</h4>
          <ul>
            <li @click="handleUploadFileTypeOneChoose(index, item)"
                :class="activeUploadFileTypeOneIndex === index?'uploadFileTypeOneActive':''"
                v-for="(item, index) in uploadFileTypeChooseOne"
                :key="index">
              {{item.fileTypeName}}
            </li>
          </ul>
        </div>
        <div v-if="uploadFileTypeChooseTwo"
             class="doc-upload-kindtwochoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
          <ul>
            <li @click="handleUploadFileTypeTwoChoose(index, item)"
                :class="activeUploadFileTypeTwoIndex === index?'uploadFileTypeTwoActive':''"
                v-for="(item, index) in uploadFileTypeChooseTwo"
                :key="index">
              {{item.fileTypeName}}
            </li>
          </ul>
        </div>
        <div v-if="uploadFileTypeChooseThree"
             class="doc-upload-kindtwochoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
          <ul>
            <li @click="handleUploadFileTypeThreeChoose(index, item)"
                :class="activeUploadFileTypeThreeIndex === index?'uploadFileTypeThreeActive':''"
                v-for="(item, index) in uploadFileTypeChooseThree"
                :key="index">
              {{item.fileTypeName}}
            </li>
          </ul>
        </div>
      </div>
      <div style="padding-left: 20px"
           slot="tip"
           class="el-upload__tip">只能上传doc/docx/pdf/ppt/pptx/xls/xlsx文件，且不超过100Mb</div>
      <el-upload class="upload-demo"
                 :before-remove="removeFile"
                 :on-success="successFile"
                 :on-error="errorFile"
                 :before-upload="beforeUpload"
                 :file-list="fileList"
                 ref="upLoadFile"
                 :limit="1"
                 :on-exceed="handleExceed"
                 :headers="headerMsg"
                 accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.pdf"
                 :action="uploadURL">
        <div slot="trigger"
             class="uploadPickUp">
          <i class="el-icon-upload2"></i> 选取文件
        </div>
        <p>文件大小不能大于100MB</p>
        <p>支持拓展名：.pdf .doc .docx .xls .xlsx .ppt .pptx</p>
        <!-- <p>文件名只支持汉字、英文字母以及数字</p> -->
        <el-button style="
            width: 265.5px;
            margin-top:50px;
            margin-left: 235px;
            border-radius: 0;
            height: 50px;
            text-aling: center;
            background: #1D65A8;
            color: white;
            border: 0;
            display: none;
          "
                   size="small"
                   type="success"
                   @click="submitUpload">确定</el-button>
      </el-upload>
      <div style="
          display:flex;
          margin-top: 40px;
          width: 530px;
          margin-left: -20px;
          margin-bottom: -30px;
          ">
        <div style=" flex: 1"
             class="upload-cancel"
             @click="cancelUpload">
          取消上传
        </div>
        <div style="
            width: 265.5px;
            border-radius: 0;
            height: 50px;
            text-aling: center;
            background: #1D65A8;
            color: white;
            text-align: center;
            line-height: 52px;
            flex: 1;
            user-select: none;
            cursor: pointer;
            font-size: 16px;
            font-weight: normal;
          "
             @click="submitUpload">
          确定上传
        </div>
      </div>
    </el-dialog>
    <!-- 列表页标题及分类展示和清空 -->
    <div class="doclist-title">
      <router-link to="/onlineTraining"
                   style="text-decoration: none; font-size: 20px; font-weight: bold;">知识培训</router-link>
      <!-- <h2>知识社区</h2> -->
      <div class="doclist-categoryone">
        <img alt="下级"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEI1QTYyRDY5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEI1QTYyRDc5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQjVBNjJENDlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQjVBNjJENTlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsbYX0sAAAE2SURBVHjajNO9zoIwFIDhA8IlALIJwuLAxOAgOOE1g5MboLIB/gwuzKDGhMh0vq9NIP4WO5BC3ocS0nJ1XcPpdELTNDn4YQir1QqLooDr9Yq2bfcifjKZwGAwgDRNYbPZYC9QVZXzPA8EQYAsy3oRTy7D4fAJrddrZAIyFEXpUJ7nEMcxMkGLFosFiKIIu93uI+JfH8iyTFdqURRFyAQtalfa7/cQhiEyARmSJHXocDi0CHnWLyRoOp3SOUHH4xGY4HK54Ha7pfPRaARk+wis2Pd9uN/vNJ7P59z/+LzCt5huvtf4fD5jEAQ01jQNXNft4jdAYvLmpmk+xk/gMdZ1HRzHeYs7UFUV/QwSj8djGn89QGVZ4nK5/CmmIEkSGhuGAbPZrPfEcbfbDcl+sSyL3veBPwEGAAUGqkVMwc6ZAAAAAElFTkSuQmCC">
        <router-link to="/trainbook"
                     style="text-decoration: none; font-size: 20px; font-weight: bold;">工业文库</router-link>
      </div>
      <!-- 一级分类选中时展示 -->
      <div class="doclist-categoryone"
           v-if="!this.activeCategoryOne">
        <img alt="下级"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEI1QTYyRDY5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEI1QTYyRDc5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQjVBNjJENDlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQjVBNjJENTlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsbYX0sAAAE2SURBVHjajNO9zoIwFIDhA8IlALIJwuLAxOAgOOE1g5MboLIB/gwuzKDGhMh0vq9NIP4WO5BC3ocS0nJ1XcPpdELTNDn4YQir1QqLooDr9Yq2bfcifjKZwGAwgDRNYbPZYC9QVZXzPA8EQYAsy3oRTy7D4fAJrddrZAIyFEXpUJ7nEMcxMkGLFosFiKIIu93uI+JfH8iyTFdqURRFyAQtalfa7/cQhiEyARmSJHXocDi0CHnWLyRoOp3SOUHH4xGY4HK54Ha7pfPRaARk+wis2Pd9uN/vNJ7P59z/+LzCt5huvtf4fD5jEAQ01jQNXNft4jdAYvLmpmk+xk/gMdZ1HRzHeYs7UFUV/QwSj8djGn89QGVZ4nK5/CmmIEkSGhuGAbPZrPfEcbfbDcl+sSyL3veBPwEGAAUGqkVMwc6ZAAAAAElFTkSuQmCC">
        <div>全部</div>
      </div>
      <div class="doclist-categoryone"
           v-if="this.activeCategoryOne">
        <img alt="下级"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEI1QTYyRDY5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEI1QTYyRDc5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQjVBNjJENDlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQjVBNjJENTlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsbYX0sAAAE2SURBVHjajNO9zoIwFIDhA8IlALIJwuLAxOAgOOE1g5MboLIB/gwuzKDGhMh0vq9NIP4WO5BC3ocS0nJ1XcPpdELTNDn4YQir1QqLooDr9Yq2bfcifjKZwGAwgDRNYbPZYC9QVZXzPA8EQYAsy3oRTy7D4fAJrddrZAIyFEXpUJ7nEMcxMkGLFosFiKIIu93uI+JfH8iyTFdqURRFyAQtalfa7/cQhiEyARmSJHXocDi0CHnWLyRoOp3SOUHH4xGY4HK54Ha7pfPRaARk+wis2Pd9uN/vNJ7P59z/+LzCt5huvtf4fD5jEAQ01jQNXNft4jdAYvLmpmk+xk/gMdZ1HRzHeYs7UFUV/QwSj8djGn89QGVZ4nK5/CmmIEkSGhuGAbPZrPfEcbfbDcl+sSyL3veBPwEGAAUGqkVMwc6ZAAAAAElFTkSuQmCC">
        <div class="doclist-category-box doclist-category-boxone">
          <div>{{activeCategoryOne}} </div>
          <div @click="cancelTypeOne"
               class="doclist-category-cancelone"></div>
        </div>
      </div>
      <!-- 二级分类选中时展示 -->
      <div class="doclist-categorytwo"
           v-if="this.activeCategoryTwo">
        <img alt="下级"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEI1QTYyRDY5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEI1QTYyRDc5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQjVBNjJENDlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQjVBNjJENTlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsbYX0sAAAE2SURBVHjajNO9zoIwFIDhA8IlALIJwuLAxOAgOOE1g5MboLIB/gwuzKDGhMh0vq9NIP4WO5BC3ocS0nJ1XcPpdELTNDn4YQir1QqLooDr9Yq2bfcifjKZwGAwgDRNYbPZYC9QVZXzPA8EQYAsy3oRTy7D4fAJrddrZAIyFEXpUJ7nEMcxMkGLFosFiKIIu93uI+JfH8iyTFdqURRFyAQtalfa7/cQhiEyARmSJHXocDi0CHnWLyRoOp3SOUHH4xGY4HK54Ha7pfPRaARk+wis2Pd9uN/vNJ7P59z/+LzCt5huvtf4fD5jEAQ01jQNXNft4jdAYvLmpmk+xk/gMdZ1HRzHeYs7UFUV/QwSj8djGn89QGVZ4nK5/CmmIEkSGhuGAbPZrPfEcbfbDcl+sSyL3veBPwEGAAUGqkVMwc6ZAAAAAElFTkSuQmCC">
        <div class="doclist-category-box  doclist-category-boxtwo">
          <div>{{activeCategoryTwo}}</div>
          <div @click="cancelTypeTwo"
               class="doclist-category-canceltwo"></div>
        </div>
      </div>
      <!-- 三级分类选中时展示 -->
      <div class="doclist-categorythree"
           v-if="this.activeCategoryThree">
        <img alt="下级"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEI1QTYyRDY5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEI1QTYyRDc5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQjVBNjJENDlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQjVBNjJENTlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsbYX0sAAAE2SURBVHjajNO9zoIwFIDhA8IlALIJwuLAxOAgOOE1g5MboLIB/gwuzKDGhMh0vq9NIP4WO5BC3ocS0nJ1XcPpdELTNDn4YQir1QqLooDr9Yq2bfcifjKZwGAwgDRNYbPZYC9QVZXzPA8EQYAsy3oRTy7D4fAJrddrZAIyFEXpUJ7nEMcxMkGLFosFiKIIu93uI+JfH8iyTFdqURRFyAQtalfa7/cQhiEyARmSJHXocDi0CHnWLyRoOp3SOUHH4xGY4HK54Ha7pfPRaARk+wis2Pd9uN/vNJ7P59z/+LzCt5huvtf4fD5jEAQ01jQNXNft4jdAYvLmpmk+xk/gMdZ1HRzHeYs7UFUV/QwSj8djGn89QGVZ4nK5/CmmIEkSGhuGAbPZrPfEcbfbDcl+sSyL3veBPwEGAAUGqkVMwc6ZAAAAAElFTkSuQmCC">
        <div class="doclist-category-box  doclist-category-boxthree">
          <div>{{activeCategoryThree}}</div>
          <div @click="cancelTypeThree"
               class="doclist-category-cancelthree"></div>
        </div>
      </div>
      <!-- 搜索时展示 -->
      <div class="doclist-categorythree"
           v-if="activeSearch">
        <img alt="检索"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEI1QTYyRDY5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEI1QTYyRDc5RTFCMTFFOUIwNjg4MEI1RjBBRjk3NUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQjVBNjJENDlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQjVBNjJENTlFMUIxMUU5QjA2ODgwQjVGMEFGOTc1QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsbYX0sAAAE2SURBVHjajNO9zoIwFIDhA8IlALIJwuLAxOAgOOE1g5MboLIB/gwuzKDGhMh0vq9NIP4WO5BC3ocS0nJ1XcPpdELTNDn4YQir1QqLooDr9Yq2bfcifjKZwGAwgDRNYbPZYC9QVZXzPA8EQYAsy3oRTy7D4fAJrddrZAIyFEXpUJ7nEMcxMkGLFosFiKIIu93uI+JfH8iyTFdqURRFyAQtalfa7/cQhiEyARmSJHXocDi0CHnWLyRoOp3SOUHH4xGY4HK54Ha7pfPRaARk+wis2Pd9uN/vNJ7P59z/+LzCt5huvtf4fD5jEAQ01jQNXNft4jdAYvLmpmk+xk/gMdZ1HRzHeYs7UFUV/QwSj8djGn89QGVZ4nK5/CmmIEkSGhuGAbPZrPfEcbfbDcl+sSyL3veBPwEGAAUGqkVMwc6ZAAAAAElFTkSuQmCC">
        <div class="doclist-category-box  doclist-category-boxthree">
          <div>{{activeSearch}}</div>
          <div @click="cancelSearch"
               class="doclist-category-cancelthree"></div>
        </div>
      </div>
      <!-- 清空筛选 -->
      <div v-if="activeCategoryOne"
           class="doclist-category-cancelall"
           @click="clearAll">
        清空筛选
      </div>
    </div>
    <!-- 列表页剩余大板 -->
    <div class="doclist-lastarea">
      <!-- 左侧分类及分页列表 -->
      <div class="doclist-lastarea-l">
        <!-- 一二三级分类分类 -->
        <div class="doclist-typelist">
          <!-- 一级分类 -->
          <div class="doclist-typelist-first"
               v-if="typeListOne">
            <div>分类</div>
            <ul>
              <li @click="changeTypeListOne(index,item)"
                  :class="index === typeListOneActiveIndex?'type-active':''"
                  v-for="(item, index) in typeListOne"
                  :key="index">{{item.fileTypeName}}</li>
            </ul>
          </div>
          <!-- 二级分类 -->
          <div class="doclist-typelist-second"
               v-if="typeListTwo">
            <!-- <div style="width: 28px;"></div> -->
            <ul style="margin-left: 48px;">
              <li @click="changeTypeListTwo(index,item)"
                  :class="index === typeListTwoActiveIndex?'type-active':''"
                  v-for="(item, index) in typeListTwo"
                  :key="index">{{item.fileTypeName}}</li>
            </ul>
          </div>
          <!-- 二级分类 -->
          <div class="doclist-typelist-third"
               v-if="typeListThree">
            <!-- <div style="width: 28px;"></div> -->
            <ul style="margin-left: 48px;">
              <li @click="changeTypeListThree(index,item)"
                  :class="index === typeListThreeActiveIndex?'type-active':''"
                  v-for="(item, index) in typeListThree"
                  :key="index">{{item.fileTypeName}}</li>
            </ul>
          </div>
        </div>
        <!-- 搜索及排序功能区 -->
        <div class="doclist-typelist-function">
          <input type="search"
                 @keypress.enter="handleSearch"
                 @change="handleSearch"
                 placeholder="请输入要查询的内容"
                 v-model="listSearch">
          <div @click="handleSearch"
               style="width:46px;height:46px;margin-left:-46px;cursor: pointer;">
          </div>
          <div class="doclist-sort"
               @click="changeSortWayInHot">
            <div :class="(orderHotNow === 1 && orderTimeNow !== 1)?'doclist-sort-active':'doclist-sort-deavtive'">热门文档</div>
            <img alt="热"
                 :src="docSortType?'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjI1OTFFMkY5RTRBMTFFOThGQTFDQkMxQzYxMDE1M0EiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjI1OTFFMzA5RTRBMTFFOThGQTFDQkMxQzYxMDE1M0EiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMjU5MUUyRDlFNEExMUU5OEZBMUNCQzFDNjEwMTUzQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMjU5MUUyRTlFNEExMUU5OEZBMUNCQzFDNjEwMTUzQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PurCCG8AAAFbSURBVHjaYrj2+P3/xQfv/AcCBkowyAyQWSwxEw4yvP70g4GRgeF/tJ0ykCIdLD1093/VkjMMonwcDEzlgXoMjIyMDFVLzzKsOf7gP6mGgfSA9ILMAJkFdu6i/bf/y6au+K+Qvur/ptOPiPY+SC1ID0gvyAyQGFxy1q4bYAnFjFX/d55/QtBQkBqQWpAekF6YOIqiSVuvgRUoZ67+v//yc5yGguRAakBqQXqQ5TAUd2+4BFaomrX6/9EbLzEMPXL9JVgOpAakFl0eqwuaV50Ha1DPWfP/1O3XcE0gNkgMJAdSg00vI9hULKBm+TlQQDPwcLAyLC9yAItF9h1g+PLjN0OcoypDS6QR1iSG00AQKF10+v/KI/cY+LnYwPyP334xhNsoMXTHmeJMr3gNBEnlzzvxf8PJh2B+gLk8w8QkC1CSYyDLQBD4B5TPmnUcrGhamiUjEyP+zAQQYADqGalt8qOlYgAAAABJRU5ErkJggg==':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODAxODFFMUU5RTRCMTFFOThGRDlGQkE3RjYwNDlENTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODAxODFFMUY5RTRCMTFFOThGRDlGQkE3RjYwNDlENTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4MDE4MUUxQzlFNEIxMUU5OEZEOUZCQTdGNjA0OUQ1MiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4MDE4MUUxRDlFNEIxMUU5OEZEOUZCQTdGNjA0OUQ1MiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuCkHTAAAAEnSURBVHjanFJNSwNBDH0ZZ0pRxGJBLSoifqIHBX+1F0FBkYp6WEEFK1YQFe3Fi+LVW2dLnE3jqrXdrQ0seZO895jNhLZ3D/nusQEK4ayFKzgkueBCdhZWsEUSTR/De484bgXs4eNwbrYzh1hfWYA93t8RcmVpk0MiDBb89lxH8pmZ1S2pvD7dSGMQM9Ui8TLJraYWN6Twcn/1X1NWDdSDjDaoPLcmoFE/79eUlQvVyrjMDwKNTS8LeKhFeaasHKgmnb3pINLI5LyA24uTXqasPSj310OaLgIqlmcF1KJqpylfnx0JUM6frTA9folcqSLg8vTgy5QVQ3tdV8xmzImGRie49fGOqLqXFkMNWftqcl6SaHj8+9DGmctv+1gPQrHEKc6JTwEGAHAcZKi8jPo7AAAAAElFTkSuQmCC'">
          </div>
          <div class="doclist-sort"
               @click="changeSortWayInNew">
            <div :class="orderTimeNow === 1?'doclist-sort-active':'doclist-sort-deavtive'">上传时间</div>
            <img alt="上传时间"
                 :src="!docSortType?'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjI1OTFFMkY5RTRBMTFFOThGQTFDQkMxQzYxMDE1M0EiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjI1OTFFMzA5RTRBMTFFOThGQTFDQkMxQzYxMDE1M0EiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMjU5MUUyRDlFNEExMUU5OEZBMUNCQzFDNjEwMTUzQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMjU5MUUyRTlFNEExMUU5OEZBMUNCQzFDNjEwMTUzQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PurCCG8AAAFbSURBVHjaYrj2+P3/xQfv/AcCBkowyAyQWSwxEw4yvP70g4GRgeF/tJ0ykCIdLD1093/VkjMMonwcDEzlgXoMjIyMDFVLzzKsOf7gP6mGgfSA9ILMAJkFdu6i/bf/y6au+K+Qvur/ptOPiPY+SC1ID0gvyAyQGFxy1q4bYAnFjFX/d55/QtBQkBqQWpAekF6YOIqiSVuvgRUoZ67+v//yc5yGguRAakBqQXqQ5TAUd2+4BFaomrX6/9EbLzEMPXL9JVgOpAakFl0eqwuaV50Ha1DPWfP/1O3XcE0gNkgMJAdSg00vI9hULKBm+TlQQDPwcLAyLC9yAItF9h1g+PLjN0OcoypDS6QR1iSG00AQKF10+v/KI/cY+LnYwPyP334xhNsoMXTHmeJMr3gNBEnlzzvxf8PJh2B+gLk8w8QkC1CSYyDLQBD4B5TPmnUcrGhamiUjEyP+zAQQYADqGalt8qOlYgAAAABJRU5ErkJggg==':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODAxODFFMUU5RTRCMTFFOThGRDlGQkE3RjYwNDlENTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODAxODFFMUY5RTRCMTFFOThGRDlGQkE3RjYwNDlENTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4MDE4MUUxQzlFNEIxMUU5OEZEOUZCQTdGNjA0OUQ1MiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4MDE4MUUxRDlFNEIxMUU5OEZEOUZCQTdGNjA0OUQ1MiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuCkHTAAAAEnSURBVHjanFJNSwNBDH0ZZ0pRxGJBLSoifqIHBX+1F0FBkYp6WEEFK1YQFe3Fi+LVW2dLnE3jqrXdrQ0seZO895jNhLZ3D/nusQEK4ayFKzgkueBCdhZWsEUSTR/De484bgXs4eNwbrYzh1hfWYA93t8RcmVpk0MiDBb89lxH8pmZ1S2pvD7dSGMQM9Ui8TLJraYWN6Twcn/1X1NWDdSDjDaoPLcmoFE/79eUlQvVyrjMDwKNTS8LeKhFeaasHKgmnb3pINLI5LyA24uTXqasPSj310OaLgIqlmcF1KJqpylfnx0JUM6frTA9folcqSLg8vTgy5QVQ3tdV8xmzImGRie49fGOqLqXFkMNWftqcl6SaHj8+9DGmctv+1gPQrHEKc6JTwEGAHAcZKi8jPo7AAAAAElFTkSuQmCC'">
          </div>
          <div class="doclist-subscribe"
               @click="handleSubscribeClick">
            <img alt="订阅"
                 :src="!subscribeOrNot?'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Mjc2OUI5QTk5RUM0MTFFOUFBQkRBMTAyM0EwQTlDMDgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Mjc2OUI5QUE5RUM0MTFFOUFBQkRBMTAyM0EwQTlDMDgiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyNzY5QjlBNzlFQzQxMUU5QUFCREExMDIzQTBBOUMwOCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyNzY5QjlBODlFQzQxMUU5QUFCREExMDIzQTBBOUMwOCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlOGiBcAAADTSURBVHjaYpRNXcFALlCT5Ps/L9eWYe+lZwz1K84zMlAAmCjR7G4owyAnwsMQ56DCQCmgyCEszJBAYGZiGliHUBOMOmTUIaMOGXXIqEOGrUNYQFU5qBZlZiK9FrdQE4OzC321////T7oDnr3/xrD+xEMGhoevP/8faFA078R/JlCj5t+//wMWJc+BIXLp0XsGRkpaaKDoKPTVAbPl01cy/v8/CBLr//+j2XfUIaMOGXXIqENGHTKMHfL03Td4VU5xC40SzaCW1X9gWwbUnqAUAAQYAJIBvR3H/6aUAAAAAElFTkSuQmCC':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NEY1MDc0REU5RUM1MTFFOTlCRUZFQkNDNjYwMDJDNEEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NEY1MDc0REY5RUM1MTFFOTlCRUZFQkNDNjYwMDJDNEEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0RjUwNzREQzlFQzUxMUU5OUJFRkVCQ0M2NjAwMkM0QSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0RjUwNzRERDlFQzUxMUU5OUJFRkVCQ0M2NjAwMkM0QSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pl5Sc0YAAAB3SURBVHja7NahDYAwFITha6lEIgk7MACOhGmYgU26AhKFR3cDEEXWIftgi9eE+yf4cuqMiKCELAqJEEIIIYQQQn4DceOyydS3qKxRAcT0YD1OOD8P6JpadQ3JAruHiJz1ztH9LRKuBMOHRgghhBBCCCGEKPcKMAA/jx3YtXWCYQAAAABJRU5ErkJggg=='">
            <!-- {{!subscribeOrNot?'订阅':'取消订阅'}} -->
            订阅
          </div>
        </div>
        <!-- 文档列表展示 -->
        <h2 v-if="doclist === null || doclist.length === 0">
          抱歉！没有搜到该资料
        </h2>
        <ul class="doclist-list"
            v-if="doclist">
          <li v-for="(item,index) in doclist"
              :key="index"
              @click="jumpDocDetail(item)">
            <!-- 左侧角标头像区域 -->
            <div class="doclist-list-left">
              <!-- 用户角标 -->
              <img alt="顶"
                   v-if="item.fileSticked"
                   class="k-doctype k-supremedoc"
                   src="data:image/png;base64,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">
              <img alt="精"
                   v-if="item.filePerfect && !item.fileSticked"
                   class="k-doctype k-supremedoc"
                   src="data:image/png;base64,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">
              <img alt="热"
                   v-if="item.fileState === 'hot' && !item.fileSticked"
                   class="k-doctype k-hotdoc"
                   src="data:image/png;base64,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">
              <img alt="新"
                   v-if="item.fileState === 'new' && !item.fileSticked"
                   class="k-doctype k-newdoc"
                   src="data:image/png;base64,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">
              <!-- 用户头像 -->
              <img class="doclist-list-authoricon"
                   :src="item.userAvatarURL"
                   :alt="item.userNickname">
            </div>
            <!-- 中间信息区域 -->
            <div class="doclist-list-text">
              <div class="overell">{{item.fileTitle}}</div>
              <div>{{item.discribe}}</div>
              <div>{{item.userNickname}} 上传 | {{item.fileCommentCount}} 个回复 | {{item.fileViewCount}} 次浏览 | {{item.createTime}}</div>
            </div>
            <!-- 右侧收藏下载功能区 -->
            <div class="doclist-list-function">
              <div class="doclist-list-like"
                   @click.stop="changeLikeState(index, item.collectionDataId, item)">
                <img :src="item.collectionDataId?likeUrl:notLikeUrl"
                     alt="收藏">
                {{item.collectionDataId?'已收藏':'收藏'}}
              </div>
              <div class="doclist-list-download"
                   @click.stop="download(item)">
                <img alt="下载"
                     src="data:image/png;base64,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">
                下载
              </div>
            </div>
          </li>
        </ul>
        <div class="doclist-pagination"
             v-if="doclist === null || doclist.length !== 0">
          <div class="doclist-lastpage"
               @click="jumpLastPage">上一页</div>
          <div class="doclist-omit">{{lastOmit}}</div>
          <ul>
            <li :class="item === currentPage?'pageactive':''"
                v-for="(item, index) in pageList"
                :key="index"
                @click="clickPageTo(item)">{{item}}</li>
          </ul>
          <div class="doclist-omit">{{nextOmit}}</div>
          <div class="doclist-nextpage"
               @click="jumpNextPage">下一页</div>
          <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text"
                   v-model.number="jumpTargetPage">页</div>
          <div class="doclist-jump"
               @click="jumpFarPage">确定</div>
        </div>
      </div>
      <!-- 右侧上传及推荐列表 -->
      <div class="doclist-lastarea-r">
        <!-- 上传按钮 -->
        <div class="doclist-upload"
             @click="showUpload">
          上传文档
        </div>
        <!-- 热门下载排行列表 -->
        <div class="doclist-hotdownloads">
          <h3>热门下载排行</h3>
          <ul v-if="hotDownloads">
            <li v-for="(item,index) in hotDownloads"
                :key="index"
                @click="jumpDocDetail(item)">
              <img alt="热门下载"
                   v-if="index + 1 === 1"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAkCAYAAABxE+FXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjQxQzlEQkVBMTE5MTFFOTlBRUNCNUJBNkFCREQ1N0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjQxQzlEQkZBMTE5MTFFOTlBRUNCNUJBNkFCREQ1N0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCNDFDOURCQ0ExMTkxMUU5OUFFQ0I1QkE2QUJERDU3QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCNDFDOURCREExMTkxMUU5OUFFQ0I1QkE2QUJERDU3QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpwY+9gAAAHZSURBVHjaYpRNXfGfYQDA1ho3BiaGAQSjlo88y1nI0aQswcvgYSgD57/68J1h9fEHtLech4OFYW62LYOSOC9c7PLDd2RZTnKw9yaYo1hMl2Dn42RlqAszYPA0kqFfnIvxczCEWysyJDipMYjycdAvwbGzMjOc6PBlYGFmon9WY2RkwLD4zvNPGOr+0zqf//z9l6F7w2UGn7bd9Ivz20Cfrjx6j2EdMCu9+fyTgZWKUYDX8h+//jI4128fLdtHLR+1fNRy+rVkfv/9xyCXtnI02Eeo5ZzsLPRNcExMjOBmc7anJoOiGC/Dwv23GebsucXw9vMP2lnOysLEEGiuwJDlocGI3HoFOSLZWY1h2eF7/2fuusHw/P036lnOBQzaKFtlhjQ3dUYJAU6sajjYmBmSnFUZYx2UGdYef/B/2o7rDA9efSHfcgFudmCLVYUhyUmNUYCbjbjQAbZyImyUGMOArd3Npx//n7L9OsPNpx+Itxzku1RXdYZoO2VGLjITFBOw5elvJscIxAy7Lj77P3nbNYaL99/itlwRGI+Z7hoMwZYKjNRsp7npSzECMcPh6y/Bjjhx8xVC0rN55//NZx79//fvP8P//7THZ+68+R8/6dB/YP/uP0CAAQBiHNQeibKNaAAAAABJRU5ErkJggg==">
              <img alt="热门下载"
                   v-if="index + 1 === 2"
                   src="data:image/png;base64,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">
              <img alt="热门下载"
                   v-if="index + 1 === 3"
                   src="data:image/png;base64,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">
              <p><span>{{index + 1}}.</span>{{item.fileTitle}}</p>
            </li>
          </ul>
        </div>
        <!-- 热门推荐列表 -->
        <div class="doclist-hotcommend">
          <h3>热门推荐</h3>
          <ul v-if="hotCommend">
            <li v-for="(item, index) in hotCommend"
                :key="index"
                @click="jumpDocDetail(item)">
              <div></div>
              <p>{{item.fileTitle}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
// 引入埋点方法
import { track } from '@/utils/knowledgeEventTracking'
export default {
  data () {
    return {
      uploadFile: null,
      headerMsg: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      uploadURL: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/fileConvert',
      fileList: [],
      activeCategoryOne: null,
      activeCategoryTwo: null,
      activeCategoryThree: null,
      typeList: null,
      typeListOne: null,
      typeListTwo: null,
      typeListThree: null,
      typeListOneActiveIndex: null,
      typeListTwoActiveIndex: null,
      typeListThreeActiveIndex: null,
      typeListOneActiveId: null,
      typeListTwoActiveId: null,
      typeListThreeActiveId: null,
      orderTimeNow: null,
      orderHotNow: 1,
      fileTypeIdNow: null,
      // 文档排序类型,1表示按照热门文档,0表示按照上传时间
      docSortType: 1,
      subscribeOrNot: false,
      activeCategoryId: null,
      currentPage: 1,
      totalPage: 4,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      likeUrl: 'data:image/png;base64,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',
      notLikeUrl: 'data:image/png;base64,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',
      hotDownloads: null,
      hotCommend: null,
      doclist: null,
      fileTypeId: null,
      activeCategoryOneIndex: null,
      activeCategoryTwoIndex: null,
      uploadFileTitle: '',
      uploadFileScore: '',
      uploadFileDescribe: '',
      activeUploadFileTypeOneIndex: null,
      activeUploadFileTypeTwoIndex: null,
      activeUploadFileTypeThreeIndex: null,
      activeUploadFileTypeTwoId: null,
      activeUploadFileTypeThreeId: null,
      uploadFileTypeChooseOne: null,
      uploadFileTypeChooseTwo: null,
      uploadFileTypeChooseThree: null,
      uploadData: null,
      isUploadShow: false,
      isSubscribeMaskShow: false,
      listSearch: '',
      activeSearch: '',
      // 订阅相关数据
      subscribeType: null,
      canSubscribeShow: null
    }
  },
  computed: {
    menuType () {
      return this.$route.query && this.$route.query.menuType ? Number(this.$route.query.menuType) : null
    }
  },
  watch: {
    '$route.query': {
      handler: 'routerWatchFun'
    }
  },
  methods: {
    routerWatchFun () {
      let docListSearch = {
        typeListOneActiveIndex: this.typeListOneActiveIndex,
        typeListTwoActiveIndex: this.typeListTwoActiveIndex,
        typeListThreeActiveIndex: this.typeListThreeActiveIndex,
        typeListOneActiveId: this.typeListOneActiveId,
        typeListTwoActiveId: this.typeListTwoActiveId,
        typeListThreeActiveId: this.typeListThreeActiveId,
        activeCategoryOne: this.activeCategoryOne,
        activeCategoryTwo: this.activeCategoryTwo,
        activeCategoryThree: this.activeCategoryThree,
        typeListTwo: this.typeListTwo,
        typeListThree: this.typeListThree
      }
      sessionStorage.setItem('docListQuery', JSON.stringify({
        ...this.$route.query,
        docListSearch
      }))
      this.getFileList()
    },
    routerPush (params = {}) {
      let query = {
        page: 1,
        limit: 10,
        fileTitle: this.$route.query.fileTitle || '',
        fileTypeId: this.$route.query.fileTypeId || null,
        orderTime: this.$route.query.orderTime || null,
        orderHot: this.$route.query.orderHot || 1,
        ...params
      }
      this.$router.push({
        name: 'bookDocList',
        query: query
      })
    },
    handleSubscribeClick () {
      if (this.canSubscribeShow === true) {
        this.isSubscribeMaskShow = true
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    handleSearch () {
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        page: this.currentPage,
        fileTitle: this.listSearch
      })
    },
    cancelUpload () {
      this.isUploadShow = false
      if (this.fileList.length) {
        for (let index = 0; index < this.fileList.length; index++) {
          this.removeFile(this.fileList[index])
        }
      }
    },
    // exportHandle() {
    //   var params = {
    //     token: Cookies.get("token"),
    //     // page: this.pageIndex,
    //     // limit: this.pageSize,
    //     // inquiryNo: this.dataForm.key,
    //     // status: this.dataForm.status,
    //     // userName: this.dataForm.userName,
    //     // userMobile: this.dataForm.userMobile,
    //     // userCompany: this.dataForm.userCompany
    //   };
    //   window.location.href = `${
    //     window.SITE_CONFIG["baseURL"]
    //   }/inquiry/inquirysheet/exportInquirySheet?${qs.stringify(params)}`;
    // },
    download (item) {
      if (this.$store.state.user.id) {
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/fileupload/alioss/isObjectExist/${item.ossId}`)
          .then(({ data }) => {
            if (data.code === 0) {
              track.clickDocDownload(item.fileTitle)
              this.downloadFile(item)
            }
          })
          .catch(() => {
            this.$message.warning('该文件不存在')
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    downloadFile (item) {
      this.$confirm(
        `下载${item.fileTitle}需要 ${item.score}积分?`,
        '提示',
        {
          confirmButtonText: '确定下载',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          return this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/userFileAddMinsPoint/${item.id}`)
        })
        .then(() => {
          let a = document.createElement('a')
          a.href = `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/aliOssDownLoad/${item.id}/${this.$store.state.user.id}`
          a.click()
        })
        .catch(err => {
          if (err !== 'cancel') {
            this.$message.warning('积分不足')
          }
        })
    },
    // getUserInfo () {
    //   this.$http.get(`${window.SITE_CONFIG['baseURL']}/admin/sys/user/registerInfo`)
    //     .then(data => {
    //     })
    //     .catch(() => {
    //     })
    // },
    handleUploadFileTypeOneChoose (index, item) {
      if (item.children === null) {
        this.$message.success('此分类仍在建设中，请选择其他分类')
        this.uploadFileTypeChooseTwo = null
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = null
        this.activeUploadFileTypeTwoId = null
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
      } else {
        this.uploadFileTypeChooseTwo = null
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = null
        this.activeUploadFileTypeTwoId = null
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.activeUploadFileTypeOneIndex = index
        this.uploadFileTypeChooseTwo = item.children
      }
    },
    handleUploadFileTypeTwoChoose (index, item) {
      if (item.children === null) {
        this.$message.error('此分类仍在建设中，请选择其他分类')
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.uploadFileTypeChooseThree = null
      } else {
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = index
        this.activeUploadFileTypeTwoId = item.id
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.uploadFileTypeChooseThree = item.children
      }
    },
    handleUploadFileTypeThreeChoose (index, item) {
      this.activeUploadFileTypeThreeIndex = index
      this.activeUploadFileTypeThreeId = item.id
    },
    handleExceed () {
      this.$message.error('上传文件数量不能超过一个')
    },
    handleSuccess (data) {
      // if (data.result.code !== 0) {
      //   this.$refs.upload.uploadFiles.pop()
      //   this.$message.error(data.result.msg || '上传失败')
      //   return false
      // }
      // this.$message.success('上传成功，请等待审核')
      // this.isUploadShow = false
      // console.log(data.result.aliOssId)
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/save`, {
        fileTitle: this.uploadFileTitle,
        score: this.uploadFileScore,
        discribe: this.uploadFileDescribe,
        fileTypeId: this.activeUploadFileTypeThreeId,
        ossId: this.fileList[0].ossId,
        downloaded: true
      })
        .then(({ data: item }) => {
          if (item.code === 0) {
            track.clickUploadFile(this.uploadFileTitle)
            this.$message.success('上传成功，请等待审核')
            this.isUploadShow = false
            this.fileList = []
            this.getFileList()
          } else {
          }
        })
        .catch(() => {
          this.$message.error('服务器记录文档失败，请检查与服务器的连接，稍后再试')
        })
    },
    showUpload () {
      if (this.$store.state.user.id) {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFileType`, {
          userId: this.$store.state.user.id || null
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.isUploadShow = true
              this.uploadFileTitle = ''
              this.uploadFileDescribe = ''
              this.uploadFileScore = 0
              this.activeUploadFileTypeOneIndex = null
              this.uploadFileTypeChooseTwo = null
              this.uploadFileTypeChooseThree = null
              this.activeUploadFileTypeTwoIndex = null
              this.activeUploadFileTypeTwoId = null
              this.activeUploadFileTypeThreeIndex = null
              this.activeUploadFileTypeThreeId = null
              this.$refs.upload.clearFiles()
            } else {
              this.$router.push({ name: 'login' })
            }
          })
          .catch(() => {
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    submitUpload (item) {
      if (this.uploadFileTitle === '' || this.uploadFileDescribe === '') {
        this.$message.error('必须填写文档标题以及文档描述才能上传文档')
      } else if (this.uploadFileTitle.length > 200) {
        this.$message.error('文档标题不能超过200字')
      } else if (!/^[0-5]{1}$/.test(this.uploadFileScore)) {
        this.$message.error('文档下载积分请输入0-5')
      } else if (this.uploadFileDescribe.length > 1000) {
        this.$message.error('文档描述不能超过1000字')
      } else if (this.activeUploadFileTypeThreeId === null) {
        this.$message.error('必须选择三级分类才能上传文档')
      } else if (this.fileList.length === 0) {
        this.$message.error('必须选择一个文档才能上传文档')
      } else {
        this.handleSuccess()
        // if (this.$refs.upload.uploadFiles[0].size > 104857600) {
        //   this.$message.error('请不要上传大于100mb的文件')
        //   this.$refs.upload.clearFiles()
        // } else {
        //   this.$refs.upload.submit()
        //   // console.log(this.$refs.upload.uploadFiles[0].name)
        //   // let newName = this.$refs.upload.uploadFiles[0].name.slice(0, this.$refs.upload.uploadFiles[0].name.lastIndexOf('.'))
        //   // // console.log(newName)
        //   // let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
        //   // // console.log(regx.test(newName))
        //   // if (regx.test(newName)) {
        //   //   this.$refs.upload.submit()
        //   // } else {
        //   //   this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        //   // }
        // }
      }
    },
    handleRemove () {
      // console.log(file, fileList);
    },
    handlePreview () {
      // console.log(file);
    },
    jumpDocDetail (item) {
      track.clickDocDetail(item.fileTitle)
      this.$router.push({
        path: '/trainbookDocDetail',
        query: {
          fileId: item.id
        }
      })
    },
    changeSortWayInHot () {
      this.orderHotNow = 1
      this.orderTimeNow = null
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        page: 1,
        orderHot: 1,
        orderTime: null
      })
    },
    changeSortWayInNew () {
      this.orderTimeNow = 1
      this.orderHotNow = null
      this.changePageTo(1)
      this.routerPush({
        page: 1,
        orderHot: null,
        orderTime: 1
      })
    },
    changeSubscribeState () {
      // console.log(this.activeCategoryTwoIndex)
      // console.log(this.activeCategoryTwo)
      // if (this.typeListTwo[this.activeCategoryTwoIndex].isSubscription === '') {
      //   this.$http.post(`${window.SITE_CONFIG['apiURL']}/userinfo/usersubscribe/userSubscribe`, {fileTypeId: this.activeCategoryId, subsribeType: 'FILE'})
      //   .then(data => {
      //     this.subscribeOrNot = true
      //     this.typeListTwo[this.typeListTwoActiveIndex].isSubscription = true
      //     this.typeListOne[this.typeListOneActiveIndex].children[this.typeListTwoActiveIndex].isSubscription = true
      //     this.$message.success('订阅成功')
      //   })
      //   .catch(error => {
      //     this.subscribeOrNot = true
      //     this.typeListTwo[this.typeListTwoActiveIndex].isSubscription = true
      //     this.typeListOne[this.typeListOneActiveIndex].children[this.typeListTwoActiveIndex].isSubscription = true
      //     this.$message.error('订阅失败，请检查网络状态')
      //   })
      // } else {
      //   this.$http.post(`${window.SITE_CONFIG['apiURL']}/userinfo/usersubscribe/cancelUserSubscribe`, {fileTypeId: this.activeCategoryId, subsribeType: 'FILE'})
      //   .then(data => {
      //     this.subscribeOrNot = false
      //     this.typeListTwo[this.typeListTwoActiveIndex].isSubscription = false
      //     this.typeListOne[this.typeListOneActiveIndex].children[this.typeListTwoActiveIndex].isSubscription = false
      //     this.$message.success('取消订阅成功')
      //   })
      //   .catch(error => {
      //     this.subscribeOrNot = false
      //     this.typeListTwo[this.typeListTwoActiveIndex].isSubscription = false
      //     this.typeListOne[this.typeListOneActiveIndex].children[this.typeListTwoActiveIndex].isSubscription = false
      //     this.$message.error('取消订阅失败，请检查网络状态')
      //   })
      // }
    },
    changeLikeState (index, likeState, item) {
      if (getAccessToken()) {
        if (!likeState) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`, { collectionType: 'FILE', collectionDataId: item.id })
            .then(({ data }) => {
              this.doclist[index].collectionDataId = 1
              this.$message.success('收藏成功')
              track.clickDocCollection(item.fileTitle)
            })
            .catch(() => {
              // this.$router.push({ name: 'login' })
            })
        } else {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`, { collectionType: 'FILE', collectionDataId: item.id })
            .then(({ data }) => {
              this.doclist[index].collectionDataId = null
              this.$message.success('取消收藏成功')
            })
            .catch(() => {
            })
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: this.currentPage
        })
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: this.currentPage
        })
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    clickPageTo (page) {
      this.changePageTo(page)
      this.routerPush({
        page: page
      })
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      // this.getFileList()
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4) {
            var newPageList3 = []
            for (let index = this.jumpTargetPage - 2; index < this.jumpTargetPage + 3; index++) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.routerPush({
          page: this.currentPage
        })
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    changeTypeListOne (index, item) {
      track.clickDocCategory(item.fileTypeName)
      this.typeListTwo = this.typeList[index].children
      this.typeListOneActiveIndex = index
      this.typeListOneActiveId = this.typeList[index].id
      this.activeCategoryOne = this.typeList[index].fileTypeName
      this.activeCategoryTwo = null
      this.activeCategoryThree = null
      this.typeListTwoActiveIndex = null
      this.typeListThreeActiveIndex = null
      this.typeListTwoActiveId = null
      this.typeListThreeActiveId = null
      this.typeListThree = null
      this.fileTypeIdNow = this.typeList[index].id
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        fileTypeId: this.fileTypeIdNow,
        page: this.currentPage
      })
      this.jumpTargetPage = 1
    },
    changeTypeListTwo (index2, item) {
      track.clickDocCategory(item.fileTypeName)
      this.typeListThree = this.typeListTwo[index2].children
      this.typeListTwoActiveIndex = index2
      this.typeListTwoActiveId = this.typeListTwo[index2].id
      this.activeCategoryTwo = this.typeListTwo[index2].fileTypeName
      this.activeCategoryThree = null
      this.typeListThreeActiveIndex = null
      this.typeListThreeActiveId = null
      this.fileTypeIdNow = this.typeListTwo[index2].id
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        fileTypeId: this.fileTypeIdNow,
        page: this.currentPage
      })
      this.jumpTargetPage = 1
    },
    changeTypeListThree (index3, item) {
      track.clickDocCategory(item.fileTypeName)
      // console.log(index3, item)
      this.typeListThreeActiveIndex = index3
      this.typeListThreeActiveId = this.typeListThree[index3].id
      this.activeCategoryThree = this.typeListThree[index3].fileTypeName
      this.fileTypeIdNow = this.typeListThree[index3].id
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        fileTypeId: this.fileTypeIdNow,
        page: this.currentPage
      })
      this.jumpTargetPage = 1
    },
    cancelTypeThree () {
      this.typeListThreeActiveId = null
      this.typeListThreeActiveIndex = null
      this.activeCategoryThree = null
      this.fileTypeIdNow = this.typeListTwoActiveId
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        fileTypeId: this.fileTypeIdNow,
        page: this.currentPage
      })
      this.jumpTargetPage = 1
    },
    cancelTypeTwo () {
      this.typeListThree = null
      this.typeListThreeActiveId = null
      this.typeListTwoActiveId = null
      this.typeListThreeActiveIndex = null
      this.typeListTwoActiveIndex = null
      this.activeCategoryThree = null
      this.activeCategoryTwo = null
      this.fileTypeIdNow = this.typeListOneActiveId
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        fileTypeId: this.fileTypeIdNow,
        page: this.currentPage
      })
      this.jumpTargetPage = 1
    },
    cancelTypeOne () {
      this.typeListThree = null
      this.typeListTwo = null
      this.typeListThreeActiveId = null
      this.typeListTwoActiveId = null
      this.typeListOneActiveId = null
      this.typeListThreeActiveIndex = null
      this.typeListTwoActiveIndex = null
      this.typeListOneActiveIndex = null
      this.activeCategoryThree = null
      this.activeCategoryTwo = null
      this.activeCategoryOne = null
      this.fileTypeIdNow = null
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        fileTypeId: this.fileTypeIdNow,
        page: this.currentPage
      })
      this.jumpTargetPage = 1
    },
    getDocList () {
      // this.$http.get(`${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfile/searchFileAtFrontGround`, {params: {page: this.currentPage, limit: 10, fileTypeId: this.fileTypeId, hotFile: this.docSortType, orderMethod: 'Desc'}})
      // .then(data => {
      //   this.doclist = data.result
      //   var page = Math.ceil(data.total / 8)
      //   this.totalPage = page
      //   if (page >= 5) {
      //     this.pageList = [1, 2, 3, 4, 5]
      //   } else {
      //     var lessPageList = []
      //     for (let index = 1; index <= page; index++) {
      //       lessPageList.push(index)
      //     }
      //     this.pageList = lessPageList
      //     this.nextOmit = ''
      //   }
      // })
    },
    cancelSearch () {
      this.listSearch = ''
      this.activeSearch = ''
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        fileTitle: '',
        page: this.currentPage
      })
    },
    clearAll () {
      // this.activeCategoryOne = this.typeListOne[0].fileTypeName
      // this.activeCategoryTwo = this.typeListOne[0].children[0].fileTypeName
      // this.activeCategoryId = this.typeListOne[0].children[0].id
      // this.changeTypeListOne(0, this.typeListOne[0])
      // this.changeTypeListTwo(0, this.typeListTwo[0])
      // this.activeCategoryOneIndex = 0
      // this.activeCategoryTwoIndex = 0
      // this.subscribeOrNot = this.typeListOne[0].children[0].isSubscription
      this.typeListThree = null
      this.typeListTwo = null
      this.typeListThreeActiveId = null
      this.typeListTwoActiveId = null
      this.typeListOneActiveId = null
      this.typeListThreeActiveIndex = null
      this.typeListTwoActiveIndex = null
      this.typeListOneActiveIndex = null
      this.activeCategoryThree = null
      this.activeCategoryTwo = null
      this.activeCategoryOne = null
      this.fileTypeIdNow = null
      this.listSearch = ''
      this.activeSearch = ''
      this.currentPage = 1
      let newSearch = this.listSearch
      this.changePageTo(1)
      this.routerPush({
        fileTypeId: null,
        fileTitle: '',
        page: this.currentPage
      })
      this.jumpTargetPage = 1
    },
    getHotDownloadList () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/hotDownload`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.hotDownloads = data.data.slice(0, 10)
          } else {
          }
        })
        .catch(() => {
        })
    },
    getHotRecommendList () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/hotRecommend`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.hotCommend = data.data.slice(0, 10)
          } else {
          }
        })
        .catch(() => {
        })
    },
    getFileTypeList (flag) {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/variableFileLevel`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.typeList = data.data
            this.typeListOne = data.data
            if (this.typeListOne && this.menuType) {
              let index = this.typeListOne.findIndex(item => {
                return item.id === this.menuType
              })
              if (index > -1) {
                this.changeTypeListOne(index, this.typeListOne[index])
              }
            }
            this.uploadFileTypeChooseOne = data.data
          }
        })
        .catch(() => {
        })
    },
    getFileList () {
      let params = {}
      if (this.$route.query.page) {
        params = {
          ...this.$route.query,
          page: Number(this.$route.query.page),
          limit: Number(this.$route.query.limit)
        }
      } else {
        params = {
          page: 1,
          limit: 10,
          fileTitle: '',
          fileTypeId: null,
          orderTime: null,
          orderHot: 1
        }
      }
      if (params.orderTime && params.orderHot) {
        params.orderHot = undefined
      }
      let newSearch = this.listSearch
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/searchFileWithFirstLevel`, params)
        .then(({ data }) => {
          this.activeSearch = newSearch
          if (data.code === 0) {
            this.doclist = data.data.data
            this.totalPage = Math.ceil(data.data.count / 10)
            this.changePageTo(params.page)
            // console.log(this.totalPage)
            // if (this.totalPage >= 5) {
            //   this.pageList = [1, 2, 3, 4, 5]
            // } else {
            //   var newPage = []
            //   for (let i = 1; i <= this.totalPage; i++) {
            //     newPage.push(i)
            //   }
            //   this.pageList = newPage
            //   this.lastOmit = ''
            //   this.nextOmit = ''
            // }
          } else {
          }
        })
        .catch(() => {
        })
    },
    getCollectType () {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFileType`, {
        userId: this.$store.state.user.id || null
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.subscribeType = data.data
            this.canSubscribeShow = true
            for (let i = 0; i < data.data.length; i++) {
              if (this.subscribeType[i].isSubscription) {
                for (let j = 0; j < this.subscribeType[i].children.length; j++) {
                  this.subscribeType[i].children[j].isSubscription = '1'
                }
              }
            }
          } else {
            this.canSubscribeShow = false
          }
        })
        .catch(() => {
        })
    },
    cancelSubscribe () {
      this.isSubscribeMaskShow = false
      this.getCollectType()
    },
    handleSubscribe () {
      let subscribeList = []
      for (let i = 0; i < this.subscribeType.length; i++) {
        if (this.subscribeType[i].isSubscription) {
          subscribeList.push(this.subscribeType[i].id)
        } else {
          for (let j = 0; j < this.subscribeType[i].children.length; j++) {
            if (this.subscribeType[i].children[j].isSubscription) {
              subscribeList.push(this.subscribeType[i].children[j].id)
            }
          }
        }
      }
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usersubscribe/userSubscribe`, {
        secondTypeIdSet: subscribeList,
        subsribeType: 'FILE'
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success('订阅成功')
            this.isSubscribeMaskShow = false
          } else {
            this.isSubscribeMaskShow = false
          }
        })
        .catch(() => {
        })
    },
    changeFirstLevelSubscribeState (index, item) {
      if (!item.isSubscription) {
        this.subscribeType[index].isSubscription = '1'
        for (let i = 0; i < item.children.length; i++) {
          this.subscribeType[index].children[i].isSubscription = '1'
        }
      } else {
        this.subscribeType[index].isSubscription = ''
        for (let i = 0; i < item.children.length; i++) {
          this.subscribeType[index].children[i].isSubscription = ''
        }
      }
    },
    changeSecondLevelSubscribeState (index, item, index2, item2) {
      if (!item2.isSubscription) {
        this.subscribeType[index].children[index2].isSubscription = '1'
        let subscribeAll = '1'
        for (let j = 0; j < item.children.length; j++) {
          if (!this.subscribeType[index].children[j].isSubscription) {
            subscribeAll = ''
          }
        }
        this.subscribeType[index].isSubscription = subscribeAll
      } else {
        this.subscribeType[index].children[index2].isSubscription = ''
        this.subscribeType[index].isSubscription = ''
      }
    },
    // 上传失败
    errorFile () {
      this.subLoading = false
    },
    // 上传成功
    successFile (response, file, fileList) {
      if (response.code === 0) {
        this.fileList.push({
          uid: file.uid,
          ossId: response.data.aliOssId,
          ossName: file.name,
          name: file.name
          // uploadId: checkpoint.uploadId
        })
        this.subLoading = false
      } else {
        // console.log(this.$refs.upLoadFile.onRemove(file, fileList), file)
        // file.onError(file)
        this.$refs.upLoadFile.abort(file) // upload: el-upload的ref值；file:File类型，file文件本身
        fileList.splice(fileList.indexOf(file), 1) // fileList: 文件列表，钩子函数中的fileList
        this.removeFile(file, fileList)
        this.$message.error(response.msg || '上传失败')
        this.subLoading = false
      }
    },
    // 上传
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
        let type = file.name.split('.')[1]
        let fileAcceptList = ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx']
        if (!fileAcceptList.includes(type)) {
          this.$message.error('请上传正确的文件类型')
          return false
        }
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
    },
    // 删除文件
    removeFile (file) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId) {
        let index = this.fileList.findIndex(item => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.fileList.splice(index, 1)
          // this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/fileupload/sys/deleteBatchAliOss`, [this.fileList[index].ossId])
          //   .then(item => {
          //     this.fileList.splice(index, 1)
          //   })
          //   .catch(() => {
          //   })
        }
      }
    }
  },
  mounted () {
    let docListQuery = sessionStorage.getItem('docListQuery')
    if (this.$route.query.page && docListQuery && JSON.parse(docListQuery) && JSON.parse(docListQuery).docListSearch) {
      docListQuery = JSON.parse(docListQuery)
      let docListSearch = docListQuery.docListSearch
      this.typeListOneActiveIndex = docListSearch.typeListOneActiveIndex
      this.typeListTwoActiveIndex = docListSearch.typeListTwoActiveIndex
      this.typeListThreeActiveIndex = docListSearch.typeListThreeActiveIndex
      this.typeListOneActiveId = docListSearch.typeListOneActiveId
      this.typeListTwoActiveId = docListSearch.typeListTwoActiveId
      this.typeListThreeActiveId = docListSearch.typeListThreeActiveId
      this.activeCategoryOne = docListSearch.activeCategoryOne
      this.activeCategoryTwo = docListSearch.activeCategoryTwo
      this.activeCategoryThre = docListSearch.activeCategoryThre
      this.typeListTwo = docListSearch.typeListTwo
      this.typeListThree = docListSearch.typeListThree
      this.page = docListQuery.page
      this.fileTypeIdNow = docListQuery.fileTypeId
      this.changePageTo(docListQuery.page)
      this.activeSearch = docListQuery.fileTitle
      this.orderTimeNow = docListQuery.orderTime
      this.orderHotNow = docListQuery.orderHot
    }
    this.getFileList()
    this.getFileTypeList()
    this.getHotDownloadList()
    this.getHotRecommendList()
    this.getCollectType()
    // this.$http.get(`${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfiletype/searchFileType`)
    //   .then(data => {
    //     this.typeListOne = data.result
    //     this.uploadFileTypeChooseOne = data.result
    //     this.typeListTwo = data.result[0].children
    //     this.uploadFileTypeChooseTwo = data.result[0].children
    //     this.activeCategoryOne = data.result[0].fileTypeName
    //     this.activeCategoryTwo = data.result[0].children[0].fileTypeName
    //     this.activeCategoryId = data.result[0].children[0].id
    //     this.fileTypeId = data.result[0].children[0].id
    //     this.activeCategoryOneIndex = 0
    //     this.activeCategoryTwoIndex = 0
    //     this.subscribeOrNot = this.typeListTwo[0].isSubscription
    //     if (this.typeListTwo === null) {
    //       this.$alert('此分类正在建设中，请浏览别的分类', '提示', {
    //         confirmButtonText: '确定'
    //       })
    //     }
    //     this.getDocList()
    //   })
    // this.$http.get(`${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfile/hotDownload`)
    // .then(data => {
    //   this.hotDownloads = data.result.slice(0, 10)
    // })
    // this.$http.get(`${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfile/hotRecommend`)
    // .then(data => {
    //   this.hotCommend = data.result.slice(0, 10)
    // })
  }
}
</script>

<style scoped>
/* 设定整体版心布局 */
.doclist {
  width: 1230px;
  padding: 0 20px;
  margin: 0 auto;
  padding-top: 20px;
  margin-bottom: 20px;
}
/* 订阅蒙版样式 */
.doc-subscribe-list {
  flex: 1;
  padding: 0 32px;
  overflow-y: auto;
}
.doc-subscribe-list h3 {
  font-size: 16px;
  line-height: 22px;
  margin-top: 20px;
  margin-bottom: 30px;
  color: #333333;
}
.subscribeFirstType {
  width: 422px;
  margin-bottom: 60px;
}
.subscribeSecondType {
  width: 466px;
  display: flex;
  flex-wrap: wrap;
}
.subscribeFirstLevel {
  margin-bottom: 40px;
}
.subscribeFirstType div {
  padding: 0 8px;
  min-width: 98px;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  text-align: center;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.2px;
  border: 1px solid #cecece;
  user-select: none;
  cursor: pointer;
}
.subscribeFirstType .activeSubscribe {
  background: #1d65a8;
  color: #ffffff;
}
.subscribeSecondType div {
  padding: 0 8px;
  min-width: 98px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  text-align: center;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.2px;
  border: 1px solid #cecece;
  margin-right: 24px;
  margin-bottom: 25px;
}
.doc-subscribe-function {
  display: flex;
  text-align: center;
}
.doc-subscribe-no {
  flex: 1;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  box-sizing: border-box;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  user-select: none;
  cursor: pointer;
}
.doc-subscribe-yes {
  flex: 1;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  background: #1d65a8;
  color: white;
  user-select: none;
  cursor: pointer;
}
/* 上传文件蒙版样式 */
.upload-cancel {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  box-sizing: border-box;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  font-size: 14px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.upload-cancel:hover {
  opacity: 0.8;
}
.doc-upload {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  padding-top: 150px;
  top: 0;
  left: 0;
  z-index: 999;
}
.uploadPickUp {
  width: 106px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #595959;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.uploadPickUp .el-icon-upload2 {
  color: #595959;
  font-size: 14px;
}
.doc-upload-area h3 {
  height: 30px;
  font-size: 20px;
  margin: 10px 0;
}
.doc-upload-area input {
  width: 92%;
  margin: 0 auto;
  line-height: 24px;
  font-size: 18px;
  display: block;
  border: 1px solid #cccccc;
  padding: 4px 10px;
  border-radius: 6px;
}
.doc-upload-area input:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-typechoose ul {
  padding-left: 80px;
}
.doc-upload-kindonechoose ul {
  margin-top: -30px;
}
.doc-upload-area textarea {
  width: 92%;
  height: 80px;
  line-height: 20px;
  resize: none;
  font-size: 16px;
  margin: 0 auto 20px auto;
  display: block;
  padding: 4px 10px;
  border: 1px solid #cccccc;
  border-radius: 6px;
}
.doc-upload-area textarea:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-area .el-upload__tip {
  word-break: break-all;
}
.doc-upload-fileorvedio {
  display: flex;
  margin-bottom: 20px;
}
.doc-upload-fileorvedio div {
  padding: 2px 10px;
  text-align: center;
  margin: 0 10px;
  border: 1px solid #1d65a8;
  user-select: none;
  cursor: pointer;
}
.uploadFileTypeOneActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindonechoose {
  margin-bottom: 20px;
}
.doc-upload-kindonechoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindonechoose ul li {
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
.uploadFileTypeTwoActive {
  background: #1d65a8;
  color: #ffffff;
}
.uploadFileTypeThreeActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindtwochoose {
  margin-bottom: 20px;
}
.doc-upload-kindtwochoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindtwochoose ul li {
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
/* 列表页标题及分类展示和清空 */
.doclist-title {
  display: flex;
  height: 28px;
  line-height: 28px;
  user-select: none;
  margin-bottom: 20px;
}
.doclist-title h2 {
  font-size: 20px;
  color: #333333;
  font-weight: 600;
}
.doclist-categoryone {
  display: flex;
}
.doclist-categoryone img {
  width: 6px;
  height: 11px;
  margin: auto 11px;
}
.doclist-categorytwo {
  display: flex;
}
.doclist-categorytwo img {
  width: 6px;
  height: 11px;
  margin: auto 11px;
}
.doclist-categorythree {
  display: flex;
}
.doclist-categorythree img {
  width: 6px;
  height: 11px;
  margin: auto 11px;
}
.doclist-category-box {
  height: 24px;
  display: flex;
  line-height: 24px;
  box-sizing: border-box;
  user-select: none;
  margin: auto 0;
}
.doclist-category-box div:nth-of-type(1) {
  text-align: center;
  padding: 0 6px;
  width: auto;
  white-space: nowrap;
}
.doclist-category-box div:nth-of-type(2) {
  width: 24px;
  cursor: pointer;
}
.doclist-category-cancelone {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDA3OEFGQjA5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDA3OEFGQjE5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEMDc4QUZBRTlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEMDc4QUZBRjlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppgy6CQAAAE4SURBVHjajNNNi4JAGAfwTT1Ivp0k0q8hXqKO5iU6+GHNIAg8aVJQJy950RQvQgQFSu4jRts64+z+D8Mjzo9xfGYGruvGcTybzRRF+forx+PxdDrpuk4bhnG9Xs/n82g0EgSBYPb7ve/7ZVmyLEtNp1OGYaqqWq1Wl8uFYIIggEKSJE3TBnVdJ0niOA5I8KZpol/7aRaLxXA4bBg8EyRqoH6xPok1vxgqsyzDmi77lBRFPZ9PrMGwVtq23RpoyXK57BgIhf7rPM9bA7nf70VRoHO6qx0Oh91uBwXP84/Ho93nfD5XVbWXvY0oirAfWGe9XmPlD+sYjuOghuOKlS+GNW2wsmEE0ydpy7I8zyOY9pUsy1EUgYRxPB7Tk8kE7gLBoLJpTxiG2+32drvV/0iappvNBhr7LcAACe08BFMfHcMAAAAASUVORK5CYII=)
    no-repeat 7.5px 7.5px;
  background-size: 9px 9px;
}
.doclist-category-canceltwo {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDA3OEFGQjA5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDA3OEFGQjE5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEMDc4QUZBRTlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEMDc4QUZBRjlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppgy6CQAAAE4SURBVHjajNNNi4JAGAfwTT1Ivp0k0q8hXqKO5iU6+GHNIAg8aVJQJy950RQvQgQFSu4jRts64+z+D8Mjzo9xfGYGruvGcTybzRRF+forx+PxdDrpuk4bhnG9Xs/n82g0EgSBYPb7ve/7ZVmyLEtNp1OGYaqqWq1Wl8uFYIIggEKSJE3TBnVdJ0niOA5I8KZpol/7aRaLxXA4bBg8EyRqoH6xPok1vxgqsyzDmi77lBRFPZ9PrMGwVtq23RpoyXK57BgIhf7rPM9bA7nf70VRoHO6qx0Oh91uBwXP84/Ho93nfD5XVbWXvY0oirAfWGe9XmPlD+sYjuOghuOKlS+GNW2wsmEE0ydpy7I8zyOY9pUsy1EUgYRxPB7Tk8kE7gLBoLJpTxiG2+32drvV/0iappvNBhr7LcAACe08BFMfHcMAAAAASUVORK5CYII=)
    no-repeat 7.5px 7.5px;
  background-size: 9px 9px;
}
.doclist-category-cancelthree {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDA3OEFGQjA5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDA3OEFGQjE5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEMDc4QUZBRTlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEMDc4QUZBRjlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppgy6CQAAAE4SURBVHjajNNNi4JAGAfwTT1Ivp0k0q8hXqKO5iU6+GHNIAg8aVJQJy950RQvQgQFSu4jRts64+z+D8Mjzo9xfGYGruvGcTybzRRF+forx+PxdDrpuk4bhnG9Xs/n82g0EgSBYPb7ve/7ZVmyLEtNp1OGYaqqWq1Wl8uFYIIggEKSJE3TBnVdJ0niOA5I8KZpol/7aRaLxXA4bBg8EyRqoH6xPok1vxgqsyzDmi77lBRFPZ9PrMGwVtq23RpoyXK57BgIhf7rPM9bA7nf70VRoHO6qx0Oh91uBwXP84/Ho93nfD5XVbWXvY0oirAfWGe9XmPlD+sYjuOghuOKlS+GNW2wsmEE0ydpy7I8zyOY9pUsy1EUgYRxPB7Tk8kE7gLBoLJpTxiG2+32drvV/0iappvNBhr7LcAACe08BFMfHcMAAAAASUVORK5CYII=)
    no-repeat 7.5px 7.5px;
  background-size: 9px 9px;
}
.doclist-category-boxone:hover .doclist-category-cancelone {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjI5RTEwMEQ5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjI5RTEwMEU5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMjlFMTAwQjlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMjlFMTAwQzlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpHD1P0AAAFpSURBVHjaYly4/7a9tkT5otPHbr5iIATS3NRTXNQ71l1kAuqRF+VZkGtrrSGGX0++j1ZNiIGEAKe5qijzS0k3bxNZDjYWH2PZc/fePn7zFZeeYj9dIOPBq89FC04xf5TzvHD/LX6dyHpCe/a//PCdCcg5fP1l8pTDP37/Beqcn4PuWkw9QDYTRA6XTqx6gICZ3zgEwnr05iuaa4Ms5LHqAQJG2dQVyE6y1RSfm2PLwcr8+88/VhYmrHoQjoQDiGvhep68/YqpB4s2IDBQFILoAQIRPg41ST5MNejacr00SwP0gIynb7+CQoiVGehmoMvxaYPrefj6S1DX3pSpR3DpRIQksp6wnn3P338HMi4+eOdlLAvUCQxhYDg/gqUEqDZMPRBpXDpB2nDpwaOTuaS8qjLYAJcerDpP3HrFvGx2Pw8HKx49mDrZWJiY/6v7fvz2q3DeyRcfvuPPb0CdJ2+/BuqZu/c2QIABACZdDnpEyh28AAAAAElFTkSuQmCC)
    no-repeat 8.5px 6.5px;
  background-size: 9px 9px;
  background-color: #1d65a8;
}
.doclist-category-boxtwo:hover .doclist-category-canceltwo {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjI5RTEwMEQ5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjI5RTEwMEU5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMjlFMTAwQjlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMjlFMTAwQzlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpHD1P0AAAFpSURBVHjaYly4/7a9tkT5otPHbr5iIATS3NRTXNQ71l1kAuqRF+VZkGtrrSGGX0++j1ZNiIGEAKe5qijzS0k3bxNZDjYWH2PZc/fePn7zFZeeYj9dIOPBq89FC04xf5TzvHD/LX6dyHpCe/a//PCdCcg5fP1l8pTDP37/Beqcn4PuWkw9QDYTRA6XTqx6gICZ3zgEwnr05iuaa4Ms5LHqAQJG2dQVyE6y1RSfm2PLwcr8+88/VhYmrHoQjoQDiGvhep68/YqpB4s2IDBQFILoAQIRPg41ST5MNejacr00SwP0gIynb7+CQoiVGehmoMvxaYPrefj6S1DX3pSpR3DpRIQksp6wnn3P338HMi4+eOdlLAvUCQxhYDg/gqUEqDZMPRBpXDpB2nDpwaOTuaS8qjLYAJcerDpP3HrFvGx2Pw8HKx49mDrZWJiY/6v7fvz2q3DeyRcfvuPPb0CdJ2+/BuqZu/c2QIABACZdDnpEyh28AAAAAElFTkSuQmCC)
    no-repeat 8.5px 6.5px;
  background-size: 9px 9px;
  background-color: #1d65a8;
}
.doclist-category-boxthree:hover .doclist-category-cancelthree {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjI5RTEwMEQ5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjI5RTEwMEU5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMjlFMTAwQjlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMjlFMTAwQzlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpHD1P0AAAFpSURBVHjaYly4/7a9tkT5otPHbr5iIATS3NRTXNQ71l1kAuqRF+VZkGtrrSGGX0++j1ZNiIGEAKe5qijzS0k3bxNZDjYWH2PZc/fePn7zFZeeYj9dIOPBq89FC04xf5TzvHD/LX6dyHpCe/a//PCdCcg5fP1l8pTDP37/Beqcn4PuWkw9QDYTRA6XTqx6gICZ3zgEwnr05iuaa4Ms5LHqAQJG2dQVyE6y1RSfm2PLwcr8+88/VhYmrHoQjoQDiGvhep68/YqpB4s2IDBQFILoAQIRPg41ST5MNejacr00SwP0gIynb7+CQoiVGehmoMvxaYPrefj6S1DX3pSpR3DpRIQksp6wnn3P338HMi4+eOdlLAvUCQxhYDg/gqUEqDZMPRBpXDpB2nDpwaOTuaS8qjLYAJcerDpP3HrFvGx2Pw8HKx49mDrZWJiY/6v7fvz2q3DeyRcfvuPPb0CdJ2+/BuqZu/c2QIABACZdDnpEyh28AAAAAElFTkSuQmCC)
    no-repeat 8.5px 6.5px;
  background-size: 9px 9px;
  background-color: #1d65a8;
}
.doclist-category-boxone:hover {
  border: 1px solid #1d65a8;
  line-height: 22px;
  color: #1d65a8;
}
.doclist-category-boxone:hover div:nth-of-type(1) {
  padding: 0 5px;
}
.doclist-category-boxtwo:hover div:nth-of-type(1) {
  padding: 0 5px;
}
.doclist-category-boxthree:hover div:nth-of-type(1) {
  padding: 0 5px;
}
.doclist-category-boxtwo:hover {
  border: 1px solid #1d65a8;
  line-height: 22px;
  color: #1d65a8;
}
.doclist-category-boxthree:hover {
  border: 1px solid #1d65a8;
  line-height: 22px;
  color: #1d65a8;
}
/* 清空筛选样式 */
.doclist-category-cancelall {
  margin-left: 16px;
  font-size: 16px;
  color: #666666;
  cursor: pointer;
}
/* 剩余大板左右布局 */
.doclist-lastarea {
  display: flex;
}
.doclist-lastarea-l {
  width: 890px;
  padding-left: 30px;
  margin-right: 20px;
  padding-top: 20px;
  background: #ffffff;
}
.doclist-lastarea-r {
  flex: 1;
}
/* 左侧一二级分类布局 */
.doclist-typelist {
  width: 888px;
  padding-left: 30px;
  margin-left: -30px;
  margin-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}
.doclist-typelist-first {
  line-height: 40px;
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #eeeeee;
}
.doclist-typelist-second {
  line-height: 40px;
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #eeeeee;
}
.doclist-typelist-third {
  line-height: 40px;
  font-size: 14px;
  color: #666666;
}
.doclist-typelist-first {
  display: flex;
}
.doclist-typelist-first div {
  margin-right: 20px;
}
.doclist-typelist-first ul {
  width: 810px;
  display: flex;
  flex-wrap: wrap;
}
.doclist-typelist-first ul li {
  margin-right: 20px;
  user-select: none;
  cursor: pointer;
}
.doclist-typelist-second {
  display: flex;
}
.doclist-typelist-second div {
  margin-right: 20px;
}
.doclist-typelist-second ul {
  display: flex;
  flex-wrap: wrap;
}
.doclist-typelist-second ul li {
  margin-right: 20px;
  user-select: none;
  cursor: pointer;
}
.doclist-typelist-third {
  display: flex;
}
.doclist-typelist-third div {
  margin-right: 20px;
}
.doclist-typelist-third ul {
  display: flex;
  flex-wrap: wrap;
}
.doclist-typelist-third ul li {
  margin-right: 20px;
  user-select: none;
  cursor: pointer;
}
.type-active {
  color: #1d65a8;
}
/* 左侧功能区样式 */
.doclist-typelist-function {
  display: flex;
  line-height: 46px;
  margin-bottom: 33px;
}
.doclist-typelist-function input {
  width: 390px;
  height: 46px;
  box-sizing: border-box;
  border: 1px solid #d3d3d3;
  text-indent: 20px;
  background: url(data:image/png;base64,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)
    no-repeat 355px 16px;
  background-size: 16px 16px;
}
.doclist-sort {
  display: flex;
  font-size: 14px;
  margin-left: 30px;
  cursor: pointer;
  user-select: none;
}
.doclist-sort img {
  width: 10px;
  height: 6px;
  margin: auto 0;
  margin-left: 8px;
}
.doclist-sort-active {
  color: #1d65a8;
}
.doclist-sort-deavtive {
  color: #666666;
}
.doclist-subscribe {
  width: 124px;
  height: 46px;
  background: #1d65a8;
  color: #ffffff;
  line-height: 46px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  user-select: none;
  margin-left: 107px;
}
.doclist-subscribe img {
  width: 17px;
  height: 17px;
  margin: 0 auto;
  margin-right: 8px;
  margin-top: -3px;
}
/* 技术文档列表样式 */
.doclist-list li {
  height: 109px;
  padding-bottom: 29px;
  margin-top: 39px;
  position: relative;
  display: flex;
  user-select: none;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.doclist-list-left {
  width: 105px;
}
.doclist-list-authoricon {
  width: 74px;
  height: 74px;
  border-radius: 50%;
}
.doclist-list-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.doclist-list-text div:nth-of-type(1) {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 22px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.doclist-list-text div:nth-of-type(2) {
  font-size: 14px;
  color: #666666;
  padding-right: 40px;
  line-height: 22px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.doclist-list-text div:nth-of-type(3) {
  font-size: 12px;
  color: #262626;
  line-height: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.k-doctype {
  width: 40px;
  height: 40px;
  position: absolute;
  top: -39px;
  left: 0;
}
.doclist-list-function {
  width: 122px;
  display: flex;
  font-size: 12px;
  color: #1d65a8;
  line-height: 138px;
}
.doclist-list-like {
  flex: 1;
  cursor: pointer;
}
.doclist-list-like img {
  width: 13px;
  height: 12px;
  margin-top: -2px;
}
.doclist-list-download {
  width: 64px;
  cursor: pointer;
}
.doclist-list-download img {
  width: 13px;
  height: 12px;
  margin-top: -2px;
}
/* 分页区域样式 */
.doclist-pagination .pageactive {
  background: #1d65a8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination {
  display: flex;
  height: 80px;
  padding: 20px 0;
  line-height: 40px;
  text-align: center;
  padding-left: 35px;
}
.doclist-pagination ul {
  display: flex;
}
.doclist-pagination ul li {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage {
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage {
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump {
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input {
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump {
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage {
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage {
  user-select: none;
  cursor: pointer;
}
.pageDeavtive {
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
/* 右侧区域样式 */
/* 上传按钮样式 */
.doclist-upload {
  width: 280px;
  height: 78px;
  background: url(data:image/png;base64,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)
    no-repeat 69px 28px;
  background-size: 28px 25px;
  background-color: #1d65a8;
  text-indent: 112px;
  line-height: 78px;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  user-select: none;
}
/* 热门下载排行样式 */
.doclist-hotdownloads {
  margin: 20px 0 30px 0;
  padding-left: 26px;
  padding-right: 20px;
  padding-bottom: 32px;
  background: #ffffff;
}
.doclist-hotdownloads h3 {
  width: 280px;
  margin-left: -26px;
  padding-left: 26px;
  height: 43px;
  line-height: 43px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  border-bottom: 1px solid #eeeeee;
}
.doclist-hotdownloads ul li {
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  user-select: none;
  cursor: pointer;
}
.doclist-hotdownloads ul li img {
  position: absolute;
  width: 15.5px;
  height: 18px;
  left: 0;
  top: 8px;
}
.doclist-hotdownloads ul li p {
  width: 233px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.doclist-hotdownloads ul li p span {
  display: inline-block;
  width: 23px;
}
/* 热门推荐样式 */
.doclist-hotcommend {
  margin: 20px 0 30px 0;
  padding-left: 26px;
  padding-right: 20px;
  padding-bottom: 32px;
  background: #ffffff;
}
.doclist-hotcommend h3 {
  margin-top: 0;
  width: 280px;
  margin-left: -26px;
  padding-left: 26px;
  height: 43px;
  line-height: 43px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  border-bottom: 1px solid #eeeeee;
}
.doclist-hotcommend ul li {
  display: flex;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  user-select: none;
  cursor: pointer;
}
.doclist-hotcommend ul li div {
  width: 6px;
  height: 6px;
  margin: auto 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #1d65a8;
}
.doclist-hotcommend ul li p {
  margin: 0;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
p {
  margin: 0;
}
a {
  color: #333;
}
a:hover {
  color: #666;
}
</style>
